import * as serviceWorker from "./serviceWorker";

import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import "./main.scss";
import "./i18n/config";

import { store } from "./redux/store/store";

if (process.env.REACT_APP_ENV !== "development") {
  console.log = function () {};
  console.error = function () {};
  console.warn = function () {};
}

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  process.env.REACT_APP_ENV === "development" ? (
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>
  ) : (
    <Provider store={store}>
      <App />
    </Provider>
  )
);

serviceWorker.register();
